import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from '../../constants';

export default function getTaxDeductionsTypes(year = '2016') {
  return API.request({
    method: 'GET',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/${year}/dict/tax-deductions`,
  });
}
